<template>
  <div class="home">
    <Header></Header>
    <HeaderTel></HeaderTel>
    <div class="head_banner">
      <el-carousel arrow="arrow" :interval="5000" :height="bannerHeight + 'px'">
        <el-carousel-item v-for="item in imgArr" :key="item">
          <a @click="dianji"><img :src="item" alt="" /></a>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="tel_head">
      <el-carousel arrow="arrow" :interval="5000" :height="600 + 'px'">
        <el-carousel-item v-for="item in telImg" :key="item">
          <a @click="tel_dianji"><img :src="item" alt="" /></a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="parent">
      <div class="left">
        <img src="@/assets/ykhome1.png" alt="" />
      </div>
      <div class="right">
        <div class="top">
          北京盈科律师事务所汇集各法律领域律师 帮您解决法律问题
        </div>
        <div class="mid">
          <span id="num21">二十余年</span><span id="zhuan">专注法律服务</span>
          <span id="all">整合全球资源为客户提供优质、高效的法律服务</span>
        </div>
        <div class="bot">
          <div class="call">
            <img src="@/assets/white_tel.png" alt="" />400-626-0148
          </div>
          <div class="zixun">
            <a class="white" @click="dianji">点击在线咨询</a>
          </div>
        </div>
      </div>
      <div class="clflo"></div>
    </div>
    <div class="content">
      <div class="left">
        <img src="@/assets/phone/tixing.png" alt="" />
      </div>
      <div class="right">
        <div class="top">
          北京盈科律师事务所汇集各法律领域精英&nbsp;&nbsp;帮您解决法律问题
        </div>
        <div class="mid">
          <span id="num21">二十余年</span><span id="zhuan">专注法律服务</span>
        </div>
        <div class="bot">
          <div class="call">
            <img src="@/assets/white_tel.png" alt="" />400-626-0148
          </div>
          <div class="zixun">
            <a class="white" @click="tel_dianji">点击在线咨询</a>
          </div>
        </div>
      </div>
      <div class="clflo"></div>
    </div>
    <div class="project">
      <div class="projects">
        <div class="left">
          <div class="left_msg">
            <div>涵盖多领域</div>
            <div>提供全方位的法律服务</div>
          </div>
        </div>
        <div class="tel_project">
          <div class="left_msg">
            <div>涵盖多领域</div>
            <div>提供全方位的法律服务</div>
          </div>
        </div>
        <div class="right">
          <ul>
            <li>
              <div class="top">
                <div><span>婚姻</span>家事</div>
                <div class="pc" @click="dianji"><a>点击咨询</a></div>
                <div class="ph" @click="tel_dianji"><a>点击咨询</a></div>
              </div>
              <div class="middle">
                <div class="middle_left">
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />协议离婚</div>
                    <div><img src="@/assets/jiantou.png" alt="" />诉讼离婚</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />子女抚养</div>
                    <div><img src="@/assets/jiantou.png" alt="" />财产分割</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />分家析产</div>
                    <div><img src="@/assets/jiantou.png" alt="" />涉外婚姻</div>
                  </div>
                  <div class="tit">
                    <div>
                      <img src="@/assets/jiantou.png" alt="" />离婚后财产纠纷
                    </div>
                  </div>
                </div>
                <div class="tel_middle_left">
                  <div><img src="@/assets/jiantou.png" alt="" />协议离婚</div>
                  <div><img src="@/assets/jiantou.png" alt="" />诉讼离婚</div>
                  <div><img src="@/assets/jiantou.png" alt="" />子女抚养</div>
                  <div><img src="@/assets/jiantou.png" alt="" />财产分割</div>
                  <div><img src="@/assets/jiantou.png" alt="" />分家析产</div>
                  <div><img src="@/assets/jiantou.png" alt="" />涉外婚姻</div>
                  <div>
                    <img src="@/assets/jiantou.png" alt="" />离婚后财产纠纷
                  </div>
                </div>
                <div class="middle_right">
                  <img src="@/assets/hunyinlianai.png" alt="" />
                </div>
              </div>
            </li>
            <li>
              <div class="top">
                <div><span>刑事</span>辩护</div>
                <div class="pc" @click="dianji"><a>点击咨询</a></div>
                <div class="ph" @click="tel_dianji"><a>点击咨询</a></div>
              </div>
              <div class="middle">
                <div class="middle_left">
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />律师会见</div>
                    <div><img src="@/assets/jiantou.png" alt="" />取保候审</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />罪轻辩护</div>
                    <div><img src="@/assets/jiantou.png" alt="" />无罪辩护</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />争取缓刑</div>
                    <div><img src="@/assets/jiantou.png" alt="" />争取改判</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />刑事控告</div>
                    <div><img src="@/assets/jiantou.png" alt="" />刑事合规</div>
                  </div>
                </div>
                <div class="tel_middle_left">
                  <div><img src="@/assets/jiantou.png" alt="" />律师会见</div>
                  <div><img src="@/assets/jiantou.png" alt="" />取保候审</div>
                  <div><img src="@/assets/jiantou.png" alt="" />罪轻辩护</div>
                  <div><img src="@/assets/jiantou.png" alt="" />无罪辩护</div>
                  <div><img src="@/assets/jiantou.png" alt="" />争取缓刑</div>
                  <div><img src="@/assets/jiantou.png" alt="" />争取改判</div>
                  <div><img src="@/assets/jiantou.png" alt="" />刑事控告</div>
                  <div><img src="@/assets/jiantou.png" alt="" />刑事合规</div>
                </div>
                <div class="middle_right">
                  <img src="@/assets/shoukao.png" alt="" />
                </div>
              </div>
            </li>
            <li>
              <div class="top">
                <div><span>房产</span>纠纷</div>
                <div class="pc" @click="dianji"><a>点击咨询</a></div>
                <div class="ph" @click="tel_dianji"><a>点击咨询</a></div>
              </div>
              <div class="middle">
                <div class="middle_left">
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />房屋确权</div>
                    <div><img src="@/assets/jiantou.png" alt="" />房屋分割</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />房产过户</div>
                    <div><img src="@/assets/jiantou.png" alt="" />违建纠纷</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />买房纠纷</div>
                    <div><img src="@/assets/jiantou.png" alt="" />借名买房</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />拆迁律师</div>
                    <div><img src="@/assets/jiantou.png" alt="" />房产继承</div>
                  </div>
                </div>
                <div class="tel_middle_left">
                  <div><img src="@/assets/jiantou.png" alt="" />房屋确权</div>
                  <div><img src="@/assets/jiantou.png" alt="" />房屋分割</div>
                  <div><img src="@/assets/jiantou.png" alt="" />房产过户</div>
                  <div><img src="@/assets/jiantou.png" alt="" />违建纠纷</div>
                  <div><img src="@/assets/jiantou.png" alt="" />买房纠纷</div>
                  <div><img src="@/assets/jiantou.png" alt="" />借名买房</div>
                  <div><img src="@/assets/jiantou.png" alt="" />拆迁律师</div>
                  <div><img src="@/assets/jiantou.png" alt="" />房产继承</div>
                </div>
                <div class="middle_right">
                  <img src="@/assets/fangchan.png" alt="" />
                </div>
              </div>
            </li>
            <li>
              <div class="top">
                <div><span>合同</span>纠纷</div>
                <div class="pc" @click="dianji"><a>点击咨询</a></div>
                <div class="ph" @click="tel_dianji"><a>点击咨询</a></div>
              </div>
              <div class="middle">
                <div class="middle_left">
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />投资合同</div>
                    <div><img src="@/assets/jiantou.png" alt="" />借款合同</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />买卖合同</div>
                    <div><img src="@/assets/jiantou.png" alt="" />房产合同</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />工程合同</div>
                    <div><img src="@/assets/jiantou.png" alt="" />股权合同</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />技术合同</div>
                    <div><img src="@/assets/jiantou.png" alt="" />服务合同</div>
                  </div>
                </div>
                <div class="tel_middle_left">
                  <div><img src="@/assets/jiantou.png" alt="" />投资合同</div>
                  <div><img src="@/assets/jiantou.png" alt="" />借款合同</div>
                  <div><img src="@/assets/jiantou.png" alt="" />买卖合同</div>
                  <div><img src="@/assets/jiantou.png" alt="" />房产合同</div>
                  <div><img src="@/assets/jiantou.png" alt="" />工程合同</div>
                  <div><img src="@/assets/jiantou.png" alt="" />股权合同</div>
                  <div><img src="@/assets/jiantou.png" alt="" />技术合同</div>
                  <div><img src="@/assets/jiantou.png" alt="" />服务合同</div>
                </div>
                <div class="middle_right">
                  <img src="@/assets/hetongguanli.png" alt="" />
                </div>
              </div>
            </li>
            <li>
              <div class="top">
                <div><span>拆迁</span>纠纷</div>
                <div class="pc" @click="dianji"><a>点击咨询</a></div>
                <div class="ph" @click="tel_dianji"><a>点击咨询</a></div>
              </div>
              <div class="middle">
                <div class="middle_left">
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />拆迁纠纷</div>
                    <div><img src="@/assets/jiantou.png" alt="" />环保拆迁</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />商铺拆迁</div>
                    <div><img src="@/assets/jiantou.png" alt="" />养殖拆迁</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />房屋征收</div>
                    <div><img src="@/assets/jiantou.png" alt="" />土地征收</div>
                  </div>
                  <div class="tit">
                    <div style="white-space: nowrap">
                      <img src="@/assets/jiantou.png" alt="" />企业征收拆迁
                    </div>
                    <div style="white-space: nowrap">
                      <img src="@/assets/jiantou.png" alt="" />棚户区改造
                    </div>
                  </div>
                </div>
                <div class="tel_middle_left">
                  <div><img src="@/assets/jiantou.png" alt="" />拆迁纠纷</div>
                  <div><img src="@/assets/jiantou.png" alt="" />环保拆迁</div>
                  <div><img src="@/assets/jiantou.png" alt="" />商铺拆迁</div>
                  <div><img src="@/assets/jiantou.png" alt="" />养殖拆迁</div>
                  <div><img src="@/assets/jiantou.png" alt="" />房屋征收</div>
                  <div><img src="@/assets/jiantou.png" alt="" />土地征收</div>
                  <div style="white-space: nowrap">
                    <img src="@/assets/jiantou.png" alt="" />企业征收拆迁
                  </div>
                  <div style="white-space: nowrap">
                    <img src="@/assets/jiantou.png" alt="" />棚户区改造
                  </div>
                </div>
                <div class="middle_right">
                  <img src="@/assets/chaiqian.png" alt="" />
                </div>
              </div>
            </li>
            <li>
              <div class="top">
                <div><span>继承</span>纠纷</div>
                <div class="pc" @click="dianji"><a>点击咨询</a></div>
                <div class="ph" @click="tel_dianji"><a>点击咨询</a></div>
              </div>
              <div class="middle">
                <div class="middle_left">
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />继承纠纷</div>
                    <div><img src="@/assets/jiantou.png" alt="" />继承顺序</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />财产继承</div>
                    <div><img src="@/assets/jiantou.png" alt="" />房产继承</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />财产赠与</div>
                    <div><img src="@/assets/jiantou.png" alt="" />继承协议</div>
                  </div>
                  <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />遗产分割</div>
                    <div><img src="@/assets/jiantou.png" alt="" />遗产保全</div>
                  </div>
                </div>

                <div class="tel_middle_left">
                  <div><img src="@/assets/jiantou.png" alt="" />继承纠纷</div>
                  <div><img src="@/assets/jiantou.png" alt="" />继承顺序</div>
                  <div><img src="@/assets/jiantou.png" alt="" />财产继承</div>
                  <div><img src="@/assets/jiantou.png" alt="" />房产继承</div>
                  <div><img src="@/assets/jiantou.png" alt="" />财产赠与</div>
                  <div><img src="@/assets/jiantou.png" alt="" />继承协议</div>
                  <div><img src="@/assets/jiantou.png" alt="" />遗产分割</div>
                  <div><img src="@/assets/jiantou.png" alt="" />遗产保全</div>
                </div>
                <div class="middle_right">
                  <img src="@/assets/jicheng.png" alt="" />
                </div>
              </div>
            </li>
            <li>
              <div class="top">
                <div><span>企业</span>法律顾问</div>
                <div class="pc" @click="dianji"><a>点击咨询</a></div>
                <div class="ph" @click="tel_dianji"><a>点击咨询</a></div>
              </div>
              <div class="middle">
                <div class="middle_left">
                  <div class="tit">
                    <div>
                      <img src="@/assets/jiantou.png" alt="" />常年法律顾问
                    </div>
                  </div>
                  <div class="tit">
                    <div>
                      <img src="@/assets/jiantou.png" alt="" />股权专项法律服务
                    </div>
                  </div>
                  <div class="tit">
                    <div>
                      <img
                        src="@/assets/jiantou.png"
                        alt=""
                      />投融资、并购法律服务
                    </div>
                    <!-- <div><img src="@/assets/jiantou.png" alt="" />律师会见</div> -->
                  </div>
                  <!-- <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />二审改判</div>
                    <div><img src="@/assets/jiantou.png" alt="" />减刑假释</div>
                  </div> -->
                </div>
                <div class="tel_middle_left">
                  <div>
                    <img src="@/assets/jiantou.png" alt="" />常年法律顾问
                  </div>
                  <div>
                    <img src="@/assets/jiantou.png" alt="" />股权专项法律服务
                  </div>
                  <div>
                    <img
                      src="@/assets/jiantou.png"
                      alt=""
                    />投融资、并购法律服务
                  </div>
                </div>
                <div class="middle_right">
                  <img src="@/assets/qiyekehu.png" alt="" />
                </div>
              </div>
            </li>
            <li>
              <div class="top">
                <div><span>知识产权</span>纠纷</div>
                <div class="pc" @click="dianji"><a>点击咨询</a></div>
                <div class="ph" @click="tel_dianji"><a>点击咨询</a></div>
              </div>
              <div class="middle">
                <div class="middle_left">
                  <div class="tit">
                    <div>
                      <img src="@/assets/jiantou.png" alt="" /><span
                        >商业秘密纠纷</span
                      >
                    </div>
                  </div>
                  <div class="tit">
                    <div>
                      <img src="@/assets/jiantou.png" alt="" /><span
                        >不正当竞争案件代理</span
                      >
                    </div>
                  </div>
                  <div class="tit">
                    <div>
                      <img src="@/assets/jiantou.png" alt="" /><span
                        style="white-space: nowrap"
                        >专利、商标、著作权纠纷</span
                      >
                    </div>
                  </div>
                </div>
                <div class="tel_middle_left">
                  <div>
                    <img src="@/assets/jiantou.png" alt="" /><span
                      >商业秘密纠纷</span
                    >
                  </div>
                  <div>
                    <img src="@/assets/jiantou.png" alt="" /><span
                      >不正当竞争案件代理</span
                    >
                  </div>
                  <div>
                    <img src="@/assets/jiantou.png" alt="" /><span
                      >专利、商标、著作权纠纷</span
                    >
                  </div>
                </div>
                <div class="middle_right">
                  <img src="@/assets/zhishichanquan.png" alt="" />
                </div>
              </div>
            </li>
            <li>
              <div class="top">
                <div><span>金融与资本市场</span>法律事务</div>
                <div class="pc" @click="dianji"><a>点击咨询</a></div>
                <div class="ph" @click="tel_dianji"><a>点击咨询</a></div>
              </div>
              <div class="middle">
                <div class="middle_left">
                  <div class="tit">
                    <div>
                      <img src="@/assets/jiantou.png" alt="" /><span
                        >金融证券法律事务</span
                      >
                    </div>
                    <!-- <div><img src="@/assets/jiantou.png" alt="" />无罪辩护</div> -->
                  </div>
                  <div class="tit">
                    <div>
                      <img src="@/assets/jiantou.png" alt="" /><span
                        >风险投资与私募股权法律事务</span
                      >
                    </div>
                    <!-- <div><img src="@/assets/jiantou.png" alt="" />不予起诉</div> -->
                  </div>
                  <div class="tit">
                    <div>
                      <img src="@/assets/jiantou.png" alt="" /><span
                        >企业风险化解及债务重组法律事务</span
                      >
                    </div>
                    <!-- <div><img src="@/assets/jiantou.png" alt="" />律师会见</div> -->
                  </div>
                  <!-- <div class="tit">
                    <div><img src="@/assets/jiantou.png" alt="" />二审改判</div>
                    <div><img src="@/assets/jiantou.png" alt="" />减刑假释</div>
                  </div> -->
                </div>
                <div class="tel_middle_left">
                  <div>
                    <img src="@/assets/jiantou.png" alt="" /><span
                      >金融证券法律事务</span
                    >
                  </div>
                  <div>
                    <img src="@/assets/jiantou.png" alt="" /><span
                      >风险投资与私募股权法律事务</span
                    >
                  </div>
                  <div>
                    <img src="@/assets/jiantou.png" alt="" /><span
                      >企业风险化解及债务重组法律事务</span
                    >
                  </div>
                </div>
                <div class="middle_right">
                  <img src="@/assets/jinrong.png" alt="" />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="bottom">
        <div class="msg">
          <div class="left">
            <div>盈科律师事务所<span>专业团队</span></div>
            <div>
              <span>深耕法律行业多年的专业律师</span
              ><span>为你提供高质量法律服务</span>
            </div>
          </div>
          <div class="right">
            <div class="pc" @click="dianji" style="">
              <a class="white">点击在线咨询</a>
            </div>
            <div class="ph" @click="tel_dianji" style="">
              <a class="white">点击在线咨询</a>
            </div>
            <div>
              <img src="@/assets/white_tel.png" alt="" /><span
                >400-626-0148
              </span>
            </div>
          </div>
          <div class="jiangbei">
            <img src="@/assets/jiangbei.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="team">
      <div class="teams">
        <div class="title">
          <img src="@/assets/yk.png" alt="" />
          <p class="zh">我们的律师团队</p>
          <p class="en">YINGKE LAW FIRM</p>
        </div>
        <div class="lawyer_list">
          <ul>
            <li>
              <div class="pic">
                <img src="@/assets/team/1.jpg" alt="" />
              </div>
              <div class="name"><span>房地产与建设工程法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/2.jpg" alt="" />
              </div>
              <div class="name"><span>婚姻家庭与继承法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/3.jpg" alt="" />
              </div>
              <div class="name"><span>合同法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/4.jpg" alt="" />
              </div>
              <div class="name"><span>民商诉讼法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/5.jpg" alt="" />
              </div>
              <div class="name"><span>刑民交叉法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/6.jpg" alt="" />
              </div>
              <div class="name"><span>刑事法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/7.jpg" alt="" />
              </div>
              <div class="name"><span>知识产权法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/8.jpg" alt="" />
              </div>
              <div class="name"><span>并购重组与企业破产法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/9.jpg" alt="" />
              </div>
              <div class="name"><span>公司法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/10.jpg" alt="" />
              </div>
              <div class="name"><span>股权法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/11.jpg" alt="" />
              </div>
              <div class="name"><span>国际商事与基础设施法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/12.jpg" alt="" />
              </div>
              <div class="name"><span>国有资产法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/13.jpg" alt="" />
              </div>
              <div class="name"><span>家族财富传承法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/14.jpg" alt="" />
              </div>
              <div class="name"><span>金融保险法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/15.jpg" alt="" />
              </div>
              <div class="name"><span>金融证券法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/16.jpg" alt="" />
              </div>
              <div class="name"><span>劳动人事法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/17.jpg" alt="" />
              </div>
              <div class="name"><span>破产与不良资产法律事务部</span></div>
            </li>
            <li>
              <div class="pic">
                <img src="@/assets/team/18.jpg" alt="" />
              </div>
              <div class="name"><span>商事诉讼与仲裁法律事务部</span></div>
            </li>
          </ul>
        </div>
        <div class="tel_lawyer_list">
          <div class="swiper-container swiper2">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <ul>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/1.jpg" alt="" />
                    </div>
                    <div class="name">
                      <span>房地产与建设工程法律事务部</span>
                    </div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/2.jpg" alt="" />
                    </div>
                    <div class="name">
                      <span>婚姻家庭与继承法律事务部</span>
                    </div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/3.jpg" alt="" />
                    </div>
                    <div class="name"><span>合同法律事务部</span></div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/4.jpg" alt="" />
                    </div>
                    <div class="name"><span>民商诉讼法律事务部</span></div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/5.jpg" alt="" />
                    </div>
                    <div class="name"><span>刑民交叉法律事务部</span></div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/6.jpg" alt="" />
                    </div>
                    <div class="name"><span>刑事法律事务部</span></div>
                  </li>
                </ul>
              </div>
              <div class="swiper-slide">
                <ul>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/7.jpg" alt="" />
                    </div>
                    <div class="name"><span>知识产权法律事务部</span></div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/8.jpg" alt="" />
                    </div>
                    <div class="name">
                      <span>并购重组与企业破产法律事务部</span>
                    </div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/9.jpg" alt="" />
                    </div>
                    <div class="name"><span>公司法律事务部</span></div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/10.jpg" alt="" />
                    </div>
                    <div class="name"><span>股权法律事务部</span></div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/11.jpg" alt="" />
                    </div>
                    <div class="name">
                      <span>国际商事与基础设施法律事务部</span>
                    </div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/12.jpg" alt="" />
                    </div>
                    <div class="name"><span>国有资产法律事务部</span></div>
                  </li>
                </ul>
              </div>
              <div class="swiper-slide">
                <ul>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/13.jpg" alt="" />
                    </div>
                    <div class="name"><span>家族财富传承法律事务部</span></div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/14.jpg" alt="" />
                    </div>
                    <div class="name"><span>金融保险法律事务部</span></div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/15.jpg" alt="" />
                    </div>
                    <div class="name"><span>金融证券法律事务部</span></div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/16.jpg" alt="" />
                    </div>
                    <div class="name"><span>劳动人事法律事务部</span></div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/17.jpg" alt="" />
                    </div>
                    <div class="name">
                      <span>破产与不良资产法律事务部</span>
                    </div>
                  </li>
                  <li>
                    <div class="pic">
                      <img src="@/assets/team/18.jpg" alt="" />
                    </div>
                    <div class="name">
                      <span>商事诉讼与仲裁法律事务部</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ask pc">
        <div class="ask1">
          <a class="white" @click="dianji">点击在线咨询</a>
        </div>
        <div class="ask2"></div>
      </div>
      <div class="ask ph">
        <div class="ask1">
          <a class="white" @click="tel_dianji">点击在线咨询</a>
        </div>
        <div class="ask2"></div>
      </div>
    </div>
    <div class="service">
      <div class="services">
        <div class="title">
          <img src="@/assets/yk.png" alt="" />
          <p class="en">YINGKE LAW FIRM</p>
          <p class="zh">盈科律师事务所</p>
          <p>服务优势</p>
        </div>
        <div class="reason">
          <ul class="left">
            <li>
              <div>委托收费透明<img src="@/assets/num/04.png" alt="" /></div>
              <div>
                严格遵守《北京市律师服务收费管理办法》收费、以解决当事人需求为首要任务，让您在无心里负担压力的前提下享受优质的法律服务。
              </div>
            </li>
            <li>
              <div>
                精于法律诉讼服务<img src="@/assets/num/05.png" alt="" />
              </div>
              <div>
                在众多法律服务中，我所涵盖业务范围广，可以委托办理民事诉讼、刑事辩护、重大疑难案件、企业法律顾问等各类案件。17000+名执业律师供您选择，成功案例丰富，盈科律师事务所是您好的选择。
              </div>
            </li>
            <li>
              <div>
                快速咨询获取专业指导<img src="@/assets/num/06.png" alt="" />
              </div>
              <div>
                在线咨询窗口10秒内快速响应客户需求，24小时提供专业服务，直接拨打电话快速咨询，在线预约专业律师，为您解决纠纷。
              </div>
            </li>
          </ul>
          <ul class="right">
            <li>
              <div>
                <img src="@/assets/num/01.png" alt="" />二十余年丰富办案经验
              </div>
              <div>
                北京市盈科律师事务所是一家全球化法律服务机构，成立于2001年，总部位于中国北京，是联合国南南合作全球智库网络联合创始机构。
              </div>
            </li>
            <li>
              <div>
                <img
                  src="@/assets/num/02.png"
                  alt=""
                />优秀的律师队伍，丰富的行业经验
              </div>
              <div>
                盈科汇聚了来自国内外知名高校的法学专业人才，多数律师取得了中、美、英、德等国的法学硕士和博士学位，半数以上的执业律师具有法律、理工、医学、计算机、金融等专业背景，多数律师还曾在企业和外国律所的工作经历。
              </div>
            </li>
            <li>
              <div><img src="@/assets/num/03.png" alt="" />全面的法律服务</div>
              <div>
                盈科全国业务指导委员会，设立盈科律师研究院、45个全国专业委员会、21个综合性法律中心；各分所共设有1000多个专业部门，业务覆盖范围广，通过不同专业、不同国家律所之间的合作，盈科满足客户在各个法律领域、全球范围的法律服务需求。
              </div>
            </li>
          </ul>
          <ul class="tel_choose">
            <li>
              <div>
                <img src="@/assets/num/01.png" alt="" />
              </div>
              <div>
                <p>二十余年丰富办案经验</p>
                北京市盈科律师事务所是一家全球化法律服务机构，成立于2001年，总部位于中国北京，是联合国南南合作全球智库网络联合创始机构。
              </div>
            </li>
            <li>
              <div>
                <img src="@/assets/num/02.png" alt="" />
              </div>
              <div>
                <p>优秀的律师队伍，丰富的行业经验</p>
                盈科汇聚了来自国内外知名高校的法学专业人才，多数律师取得了中、美、英、德等国的法学硕士和博士学位，半数以上的执业律师具有法律、理工、医学、计算机、金融等专业背景，多数律师还曾在企业和外国律所的工作经历。
              </div>
            </li>
            <li>
              <div><img src="@/assets/num/03.png" alt="" /></div>
              <div>
                <p>全面的法律服务</p>
                盈科全国业务指导委员会，设立盈科律师研究院、45个全国专业委员会、21个综合性法律中心；各分所共设有1000多个专业部门，业务覆盖范围广，通过不同专业、不同国家律所之间的合作，盈科满足客户在各个法律领域、全球范围的法律服务需求。
              </div>
            </li>
            <li>
              <div><img src="@/assets/num/04.png" alt="" /></div>
              <div>
                <p>委托收费透明</p>
                严格遵守《北京市律师服务收费管理办法》收费、以解决当事人需求为首要任务，让您在无心里负担压力的前提下享受优质的法律服务。
              </div>
            </li>
            <li>
              <div>
                <img src="@/assets/num/05.png" alt="" />
              </div>
              <div>
                <p>精于法律诉讼服务</p>
                在众多法律服务中，我所涵盖业务范围广，可以委托办理民事诉讼、刑事辩护、重大疑难案件、企业法律顾问等各类案件。17000+名执业律师供您选择，成功案例丰富，盈科律师事务所是您好的选择。
              </div>
            </li>
            <li>
              <div>
                <img src="@/assets/num/06.png" alt="" />
              </div>
              <div>
                <p>快速咨询获取专业指导</p>
                在线咨询窗口10秒内快速响应客户需求，24小时提供专业服务，直接拨打电话快速咨询，在线预约专业律师，为您解决纠纷。
              </div>
            </li>
          </ul>
          <div class="tel_tit">
            <p>为什么选择我们</p>
            <p>给您不后悔的理由</p>
          </div>
          <div class="choose">
            <p>为什么选择我们</p>
            <p>给您不后悔的理由</p>
          </div>
        </div>
      </div>
      <div class="ask pc">
        <div class="ask1">
          <a class="white" @click="dianji">点击在线咨询</a>
        </div>
        <div class="ask2"></div>
      </div>
      <div class="ask ph">
        <div class="ask1">
          <a class="white" @click="tel_dianji">点击在线咨询</a>
        </div>
        <div class="ask2"></div>
      </div>
    </div>
    <div class="introduce">
      <div class="introduces">
        <div class="title">
          <img src="@/assets/yk.png" alt="" />
          <p class="zh">盈科介绍</p>
          <p class="en">YINGKE LAW FIRM</p>
        </div>
        <div class="introduces_msg">
          <div class="left">
            <div class="logos"><img src="@/assets/yklogo3.png" alt="" /></div>
            <div class="biaoti">
              <p>关于盈科律师事务所</p>
              <p>来自中国的全球化 法律服务机构</p>
              <p>提供全球一站式 商务法律服务事务所服务优势</p>
            </div>
            <i class="fenge"></i>
            <div class="jianjie">
              北京市盈科律师事务所是一家全球化法律服务机构，成立于2001年，总部位于中国北京，是联合国南南合作全球智库网络联合创始机构。
              <br />
              基于全球布局，盈科坚持“以客户为导向，以律师为本，律师事务所可持续发展，党和人民满意”的发展原则，全面加强专业化建设，在全国层面设立45个专业委员会、21个综合性法律中心，各分所共设立1000余个专业部门，满足客户在各个法律领域、全球范围的法律服务需求。此外，盈科聘请了在国内外法学理论及实务领域享有声誉的多位法学专家担任专家顾问。盈科律师事务所20000余名员工，致力于为客户提供全球商务法律服务，为客户创造价值。盈科成立二十余年来，已累计为超过1000000家海内外企业提供高度满意的法律服务。
            </div>
          </div>
          <div class="right">
            <img src="@/assets/ykhome2.png" alt="" />
          </div>
          <div class="jieshao">
            <ul>
              <li>
                <img src="@/assets/duigou.png" alt="" />
                <div>2001</div>
                成立
              </li>
              <li>
                <img src="@/assets/duigou.png" alt="" />
                <div>120+</div>
                分所
              </li>
              <li>
                <img src="@/assets/duigou.png" alt="" />
                <div>17000+</div>
                律师
              </li>
              <li>
                <img src="@/assets/duigou.png" alt="" />
                <div>45个</div>
                专业委员会
              </li>
              <li>
                <img src="@/assets/duigou.png" alt="" />
                <div>20+</div>
                综合性法律中心
              </li>
              <li>
                <img src="@/assets/duigou.png" alt="" />
                <div>1000+</div>
                专业部门
              </li>
            </ul>
          </div>
        </div>
        <div class="huanjing">
          <ul>
            <li><img src="@/assets/yk/1.png" alt="" /></li>
            <li><img src="@/assets/yk/2.png" alt="" /></li>
            <li><img src="@/assets/yk/3.png" alt="" /></li>
            <li><img src="@/assets/yk/4.png" alt="" /></li>
            <li><img src="@/assets/yk/5.png" alt="" /></li>
            <li><img src="@/assets/yk/6.png" alt="" /></li>
            <li><img src="@/assets/yk/7.png" alt="" /></li>
            <li><img src="@/assets/yk/8.png" alt="" /></li>
            <li><img src="@/assets/yk/9.png" alt="" /></li>
            <li><img src="@/assets/yk/10.png" alt="" /></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="casePos">
      <div class="casePosMain">
        <div class="leftPos">
          <img src="@/assets/zixun.png" alt="" />
        </div>
        <div class="telTit">立即案件咨询</div>
        <div class="rightPos">
          <el-form>
            <el-row class="Item-flex">
              <el-col class="left">
                <el-form-item class="inputPos">
                  <div class="user">*</div>
                  <el-input
                    placeholder="请输入您的姓名"
                    v-model="form.username"
                  ></el-input>
                </el-form-item>
                <el-form-item id="yourtel">
                  <div class="user">*</div>
                  <el-input
                    placeholder="请输入您的手机号码"
                    class="userPhone"
                    v-model="form.phone"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item class="idcode">
                  <div class="user">*</div>
                  <el-input placeholder="验证码" v-model="form.code"></el-input>
                  <el-button class="sendCode" @click="GetCode(form.phone)">{{
                    isSendCode
                  }}</el-button>
                </el-form-item>
                <el-form-item class="leibie" id="leibie">
                  <el-select placeholder="咨询类别" v-model="form.advisoryType">
                    <el-option label="民事" value="38"></el-option>
                    <el-option label="刑事" value="39"></el-option>
                    <el-option label="行政" value="40"></el-option>
                    <el-option label="其他" value="41"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="question">
                  <el-input
                    placeholder="请输入您的案件描述"
                    v-model="form.problemDes"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col class="right">
                <el-form-item>
                  <el-button
                    class="submit"
                    @click="onSubmit"
                    :disabled="disabled"
                    >发送</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "@/components/footer.vue";
import Header from "@/components/header.vue";
import HeaderTel from "@/components/header_tel.vue";

import "swiper/css/swiper.css";
import Swiper from "swiper";
export default {
  data() {
    return {
      bannerHeight: "",
      imgArr: [
        require("@/assets/banner/3.png"),
        // require("@/assets/banner/2.jpg"),
        require("@/assets/banner/1.png"),
      ],
      telImg: [
        require("@/assets/banner/tel2.jpg"),
        // require("@/assets/banner/tel2.jpg"),
        require("@/assets/banner/tel1.png"),
      ],
      isSendCode: "发送验证码",
      disabled: false,
      form: {
        username: "",
        phone: "",
        address: "",
        advisoryType: "",
        problemDes: "",
        code: "",
      },
    };
  },
  name: "Home",
  components: {
    Footer,
    Header,
    HeaderTel,
  },
  mounted() {
    //添加滚动监听
    window.addEventListener("scroll", this.handleScroll);
    // 首次加载时,初始化高度
    this.screenWidth = window.innerWidth;
    this.bannerHeight = (720 / 1920) * this.screenWidth;
    // 窗口大小发生改变
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.bannerHeight = (720 / 1920) * this.screenWidth;
    };

    new Swiper(".swiper-container", {
      loop: true, // 循环模式选项
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
      },
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },

      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  },
  methods: {
    //获取验证码
    GetCode(phone) {
      // if (this.isSendCode == "已发送") {
      //   return false;
      // }

      this.guid = this.getGuid();
      if (this.form.phone == "") {
        alert("请填写手机号");
        return false;
      } else if (!/^1[3|4|5|7|8][0-9]{9}$/.test(phone)) {
        alert("请填写正确的手机号");
        return false;
      }
      // this.isSendCode = "已发送";
      if (this.isSendCode == "发送验证码") {
        this.axios
          .get(
            `https://www.yingkelawyer.com/Ajax/Index/IndexAjax.ashx?_=0.2138540338262398&temp=SendMessage&guid=0.246140907954578&Phone=${this.form.phone}`
          )
          // .get(
          //   `http://172.16.17.103:8082/Ajax/Index/IndexAjax.ashx?_=0.2138540338262398&temp=SendMessage&guid=0.246140907954578&Phone=${this.form.phone}`
          // )
          .then((res) => {
            if (res) {
              this.isSendCode = 60;
              let Rcodecount = setInterval(() => {
                this.isSendCode--;
                if (this.isSendCode <= 0) {
                  clearInterval(Rcodecount);
                  this.isSendCode = "发送验证码";
                }
              }, 1000);
            }
          });
      }
    },
    //提交表单
    onSubmit() {
      if (this.form.username == "") {
        alert("请输入您的姓名");
        return false;
      }

      if (this.form.phone == "") {
        alert("请填写您的手机号");
        return false;
      }
      if (this.form.code == "") {
        alert("请输入您收到的验证码");
        return false;
      }
      if (this.form.advisoryType == "") {
        alert("请选择咨询类别");
        return false;
      }
      if (this.form.problemDes == "") {
        alert("请输入问题概述");
        return false;
      }
      //验证输入的验证码是否正确
      if (this.guid == undefined) {
        alert("发送失败,请重新输入您的信息");
        return false;
      }

      this.disabled = true;
      this.axios({
        dataType: "json",
        type: "GET",
        method: "post",
        crossDomain: true,
        // url: this.Url.apiUrl + "v/code/" + this.guid + "",
        url: "https://www.yingkelawyer.com/Ajax/Index/IndexAjax.ashx",
        // url: "http://172.16.17.103:8082/Ajax/Index/IndexAjax.ashx",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          _: Math.random(),
          temp: "AddPublicCase",
          guid: "0.246140907954578",
          mode: "360",
          CompanyName: "",
          OfficeArea: "",
          Email: "",
          UserName: this.form.username,
          Phone: this.form.phone,
          code: this.form.code,
          CaseType: this.form.advisoryType,
          advisoryType: this.form.problemDes,
          CaseRemark: "123456",
          OfficeID: 1,
          Guquan: false,
        },
      }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          alert("验证码不正确,请重新输入");
          this.disabled = false;
          return false;
        } else {
          alert("提交成功");
          this.disabled = true;
        }

        // if (res.code == 0) {
        //   alert("验证码不正确,请重新输入");
        //   this.disabled = false;
        //   return false;
        // } else {
        //提交表单
        // this.axios({
        //   dataType: 'json',
        //   type: 'GET',
        //   method: "post",
        //   // url: this.Url.apiUrl + "SystemOption/CaseAdvisory",
        //   // url: this.Url.apiUrl + "mail/send",
        //   url: "http://www.yingkelawyer.com/Ajax/Index/IndexAjax.ashx",
        //   data: this.form,
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        // }).then(() => {
        // alert("提交成功");
        // this.disabled = true;
        // });
        // }
      });
    },
    //获取随机 guid
    getGuid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      );
    },
    dianji() {
      console.log(111);

      // document.getElementsByClassName("nb-icon-inner-wrap")[0].click();
      document.getElementsByClassName("embed-icon-pcIcon5")[0].click();
    },
    tel_dianji() {
      console.log(222);
      document.getElementsByClassName("embed-icon-content")[0].click();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/home.scss";
</style>


<style>
.Item-flex .left .idcode .el-form-item__content {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: #fff;
}
.Item-flex .left .idcode .el-input__inner {
  width: 130px;
}
.Item-flex .left .sendCode {
  color: #be9d6d;
  padding: 12px 10px;
  border: 0;
  outline: 0;
}
.Item-flex .el-button:hover {
  background-color: #fff;
}
.Item-flex .el-input__inner {
  border: 0;
  border-radius: 2px;
  width: 240px;
}
.Item-flex .el-form-item {
  margin-right: 10px;
  margin-bottom: 5px;
  margin-top: 5px;
}
.leibie .el-form-item__content .el-select {
  width: 240px;
}
.Item-flex .question .el-input__inner {
  width: 470px;
}
.Item-flex .right .submit {
  width: 160px;
  background-color: #ffb515;
  border: #ffb515 1px solid;
  color: #fff;
}
@media screen and (max-width: 750px) {
  .Item-flex .el-input__inner {
    width: 170px;
  }
  .Item-flex .left .idcode .el-input__inner {
    width: 80px;
  }
  .Item-flex .question .el-input__inner {
    width: 350px;
  }
  .leibie .el-form-item__content .el-select {
    width: 170px;
  }
  .Item-flex .right .submit {
    border-radius: 50px;
    margin: 10px 0;
  }
}
</style>
<style scoped>
.tel_head .el-carousel__container {
  height: 30rem !important;
}
@media screen and (max-width: 750px) {
  .tel_head .el-carousel__container {
    height: 40rem !important;
  }
}
.head_banner {
  width: 100%;
}

.head_banner .el-carousel__container img {
  width: 100%;
  height: inherit;
}
.tel_head {
  height: 30rem;
}
.tel_head .el-carousel {
  width: 100%;
  height: 30rem;
}
.tel_head .el-carousel__container .el-carousel__item img {
  width: 100%;
}
</style>